module.exports = __webpack_public_path__ + "img/title_pc.13cd0687.svg";